export default __webpack_public_path__ + "static/media/avatar-s-10.79a4ca26.jpg";